import { type JSX, Show } from 'solid-js';
import { t } from '../../i18n';

// One projection row of a drop panel (#6771, prototype projRow `:1939`): "CPU" or "Memory",
// the before share as a bar with the added share as its own segment (accent below 70%, amber
// at 70% or more, red above 90%), and "a% → b%" with the after value bold, coloured at 70% or
// more. The after half is the server preview's; with no projection it is omitted and the row
// shows the machine's own reading only, never an estimate.

export function MoveProjRow(props: {
  readonly label: string;
  readonly before: number;
  readonly after: number | null;
}): JSX.Element {
  const before = () => Math.round(props.before);
  const after = () => (props.after === null ? null : Math.round(props.after));
  const tone = (a: number): 'live' | 'warn' | 'over' =>
    a > 90 ? 'over' : a >= 70 ? 'warn' : 'live';
  const added = (a: number) => Math.max(0, Math.min(a, 100) - Math.min(before(), 100));
  return (
    <div class="move-proj">
      <span>{props.label}</span>
      <span class="move-proj__bar">
        <i class="move-proj__base" style={{ width: `${Math.min(Math.max(before(), 0), 100)}%` }} />
        <Show when={after()}>
          {(a) => <i class={`move-proj__add--${tone(a())}`} style={{ width: `${added(a())}%` }} />}
        </Show>
      </span>
      <Show
        when={after() !== null}
        fallback={
          <span class="move-proj__value">{t('fleet.machines.percent', { value: before() })}</span>
        }
      >
        <span class="move-proj__value">
          {t('fleet.move.panel_before', { value: before() })}{' '}
          <b data-tone={(after() ?? 0) >= 70 ? tone(after() ?? 0) : undefined}>
            {t('fleet.machines.percent', { value: after() ?? 0 })}
          </b>
        </span>
      </Show>
    </div>
  );
}
